import styled from "@emotion/styled";
import { motion } from "@smartsheet/design-tokens";

export interface BadgeProps {
    backgroundColor: string;
    color: string;
    size: number;
    /**
     * A number (in px) to offset the location of the badge from it's default location.
     *
     * Note: This is relative to the default location of the badge, not the target element
     */
    readonly offset?: {
        /**
         * The horizontal distance from the default locaton.
         * A positive value moves further right
         * A negative value moves further left
         */
        readonly x?: number;
        /**
         * The vertical distance from the default location.
         * A positive value moves further up
         * A negative value moves further down
         */
        readonly y?: number;
    };
}

// This component is not meant to be shipped to consumers.
export const Badge = styled("span")<BadgeProps>`
    ${({ backgroundColor, size, color }) => `
        box-sizing: content-box;
        background-color: ${backgroundColor};
        height: ${size}px;
        color: ${color};
        font-size: ${size === 16 ? 10 : 8}px;
        font-weight: 700;
        font-family: inherit;
        line-height: 8px;
        letter-spacing: -0.2px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        transition: all ${motion.animation.default};
    `}
`;
